export default "__VITE_ASSET__DtO190TZ__"